import React, { useState, useEffect } from 'react';
import { Button, Card, Col, Image, Row } from 'react-bootstrap';
import { motion } from 'framer-motion';

export default function MenuItems({ menuData }) {
    const [favorites, setFavorites] = useState(() => {
        const saved = localStorage.getItem('favorite_items');
        return saved ? JSON.parse(saved) : [];
    });

    useEffect(() => {
        const handleStorageChange = () => {
            const saved = localStorage.getItem('favorite_items');
            setFavorites(saved ? JSON.parse(saved) : []);
        };
        window.addEventListener('storage', handleStorageChange);
        return () => window.removeEventListener('storage', handleStorageChange);
    }, []);

    const toggleLike = (item) => {
        const isAlreadyFavorite = favorites.some(fav => fav.menuItemName === item.menuItemName);
        let updated;
        if (isAlreadyFavorite) {
            updated = favorites.filter(fav => fav.menuItemName !== item.menuItemName);
        } else {
            updated = [...favorites, item];
        }
        setFavorites(updated);
        localStorage.setItem('favorite_items', JSON.stringify(updated));
        window.dispatchEvent(new Event('localStorageChange'));
    };

    const addToCart = (item) => {
        const savedCart = localStorage.getItem('cart_items');
        const currentCart = savedCart ? JSON.parse(savedCart) : [];
        const existingIndex = currentCart.findIndex(cartItem => cartItem.menuItemName === item.menuItemName);
        let updatedCart;

        if (existingIndex > -1) {
            updatedCart = currentCart.map((cartItem, index) =>
                index === existingIndex
                    ? { ...cartItem, quantity: (cartItem.quantity || 1) + 1 }
                    : cartItem
            );
        } else {
            updatedCart = [...currentCart, { ...item, quantity: 1 }];
        }

        localStorage.setItem('cart_items', JSON.stringify(updatedCart));
        window.dispatchEvent(new Event('localStorageChange'));
    };

    if (!menuData) {
        return <div className='text-center mt-5'>No Data Available</div>;
    }

    return (
        <>
            <Row className='justify-content-center'>
                {menuData.map((data, i) => (
                    <Col sm={6} lg={4} xxl={3} key={i} className='mb-4'>
                        <motion.div initial={{opacity: 0 ,y: -20}} viewport={{once: true}} whileInView={{opacity: 1, y: 0}} transition={{duration: 0.5}} custom={i}>

                        <Card className='card-hover menu-item-card h-100 mb-0'>
                            <Card.Body className='pb-0'>
                                <motion.div className='menu-item-img-box px-3 py-2 rounded-3' initial={{opacity: 0}} viewport={{once: true}} whileInView={{opacity: 1}} transition={{duration: 0.5}} custom={i}>
                                    <Image src={require(`../../images/menu-item/${data.menuFoodImg}`)} alt="" className='img-fluid png-img-shadow-sm' />
                                </motion.div>
                                <motion.div className='d-flex justify-content-between mt-3' initial={{opacity: 0}} viewport={{once: true}} whileInView={{opacity: 1}} transition={{duration: 0.5}} custom={i}>
                                    <h5 className='mb-0 fw-semibold'>{data.menuItemName}</h5>
                                    <div className='ms-3 cursor'>
                                        {favorites.some(fav => fav.menuItemName === data.menuItemName) ? (
                                            <i className="ri-heart-fill fs-20 text-danger" onClick={() => toggleLike(data)}></i>
                                        ) : (
                                            <i className="ri-heart-line fs-20 menu-like-icon" onClick={() => toggleLike(data)}></i>
                                        )}
                                    </div>
                                </motion.div>
                                <motion.p className='text-muted' initial={{opacity: 0}} viewport={{once: true}} whileInView={{opacity: 1}} transition={{duration: 0.5}} custom={i}>{data.menuItemDesc}</motion.p>
                            </Card.Body>
                            <Card.Footer className='bg-transparent border-0 pt-0 pb-3'>
                                <motion.div className='d-flex gap-1 text-warning' initial={{opacity: 0}} viewport={{once: true}} whileInView={{opacity: 1}} transition={{duration: 0.5}} custom={i}>
                                    <i className="ri-star-fill"></i>
                                    <i className="ri-star-fill"></i>
                                    <i className="ri-star-fill"></i>
                                    <i className="ri-star-fill"></i>
                                    <i className="ri-star-fill"></i>
                                </motion.div>
                                <hr className='border-soft-dark' />
                                <motion.div className='d-flex align-items-center justify-content-between' initial={{opacity: 0}} viewport={{once: true}} whileInView={{opacity: 1}} transition={{duration: 0.5}} custom={i}>
                                    <h5 className='text-danger fw-semibold mb-0'>{data.menuItemPrice}</h5>
                                    <Button variant='soft-danger' className='btn btn-xs' onClick={() => addToCart(data)}>Add to Card</Button>
                                </motion.div>
                            </Card.Footer>
                        </Card>
                        </motion.div>
                    </Col>
                ))}
            </Row>
        </>
    )
}
